import { useEffect, useState } from "react";
import type { DateRange } from "react-day-picker";
import DateRangeCalendar from "@/components/DateRangeCalendar";
import { useBookingContext } from "@/contexts/BookingContext";

export default function Dates() {
  const { state, actions } = useBookingContext();

  const [dateRange, setDateRange] = useState<DateRange | undefined>(
    state.dateFrom && state.dateUntil ? { from: state.dateFrom, to: state.dateUntil } : undefined,
  );

  useEffect(() => {
    // sync selected range to context
    if (dateRange?.from && dateRange?.to && dateRange.from !== dateRange.to) {
      actions.setDateFrom(dateRange.from);
      actions.setDateUntil(dateRange.to);
    } else {
      actions.setDateFrom(null);
      actions.setDateUntil(null);
    }
  }, [dateRange, actions]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    // handle state reset
    if (
      // range is empty in context
      !state.dateFrom &&
      !state.dateUntil &&
      // not empty in component
      dateRange?.from &&
      dateRange?.to &&
      // selected more than one day, because in this case
      // we also don't store range in context
      dateRange.from !== dateRange.to
    ) {
      setTimeout(() => setDateRange(undefined));
    }
  }, [state.dateFrom, state.dateUntil]);

  return (
    <DateRangeCalendar
      dateRange={dateRange}
      onSelect={setDateRange}
      defaultMonth={dateRange?.from || new Date()}
      sx={{
        "& .rdp-root": {
          borderWidth: "1px 0px 0px 0px",
          borderColor: "divider",
          borderStyle: { xs: "none", md: "solid" },
          height: { xs: "auto", md: "100%" },
        },
      }}
    />
  );
}
